import React, { Fragment, useContext } from 'react';
import { StoreContext } from '../containers/Store';
import Path from '../pages/Path';
import { Row, Col, Button, Card } from 'antd';
import paths from '../data/paths';

export default () => {
  const {
    user: {
      user
    },
    drawer: {
      setRightDrawer,
      setRightDrawerTitle,
    },
    action: {
      resetActivity
    }
  } = useContext(StoreContext);

  const extractDifficulty = (pathId) => {
    if (!!paths) {
      if (paths.filter(p =>
          p.path === pathId).length > 0) {
        const path = paths.filter(p =>
          p.path === pathId)[0];
        return path.difficulte.split('_').map((frag, index) => {
          if (index % 2 !== 0) {
            return <em>{frag}</em>
          } else {
            return frag
          }
        });
      } else {
        return ""
      }
    } else {
      return ""
    }
  }

  const extractDescription = (pathId) => {
    if (!!paths) {
      if (paths.filter(p =>
          p.path === pathId).length > 0) {
            const path = paths.filter(p =>
              p.path === pathId)[0];
        return path.description.split('_').map((frag, index) => {
          if (index % 2 !== 0) {
            return <em>{frag}</em>
          } else {
            return frag
          }
        });
      } else {
        return ""
      }
    } else {
      return ""
    }
  }

  return (
    <Fragment>

      <Card
        style={{ margin: '16px', maxWidth: '800px' }}
      >
        <Card.Meta title="Appréhender et manipuler intuitivement la structure syntaxique d’une phrase" />
      </Card>
      <Button
        type="primary"
        onClick={() => {
          setRightDrawerTitle('Test diagnostique');
          setRightDrawer(true);
          resetActivity({ activityId: 0, path: 0 })
        }}
        style={{ marginLeft: '50px', marginTop: '20px'}}
      >
        Test diagnostique
      </Button>
      <br />
      <br />
      <br />

      <Row gutter={16} type="flex" justify="space-between" align="top" style={{ paddingBottom: '16px' }}>
        <Col md={8} xs={24}>
          <Card>
            <Card.Meta
              title={`Premier parcours`}
            />
            <br />
            <h4> <em>Objectif</em> </h4>
            <p>{extractDescription(1)}</p>
            <h4> <em>Difficultés visées</em> </h4>
            <p>{extractDifficulty(1)}</p>
          </Card>
          <Path path={1} />
        </Col>
        <Col md={8} xs={24}>
          <Card>
            <Card.Meta
              title={`Deuxième parcours`}
            />
            <br />
            <h4> <em>Objectif</em> </h4>
            <p>{extractDescription(2)}</p>
            <h4> <em>Difficultés visées</em> </h4>
            <p>{extractDifficulty(2)}</p>
          </Card>
          <Path path={2} />
        </Col>
        <Col md={8} xs={24}>
        <Card>
            <Card.Meta
              title={`Troisième parcours`}
            />
            <br />
            <h4> <em>Objectif</em> </h4>
            <p>{extractDescription(3)}</p>
            <h4> <em>Difficultés visées</em> </h4>
            <p>{extractDifficulty(3)}</p>
          </Card>
          <Path path={3} />
        </Col>
      </Row>
    </Fragment>
  )
}